export const changeableAccountTypes = [
    'INVESTMENT',
    'LOAN',
    'MORTGAGE',
    'CHECKING',
    'CRYPTO',
    'SAVINGS',
    'CREDITCARD',
    'OTHER',
    'VEHICLE',
    'REAL_ESTATE',
    'PENSION',
];
